import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useGetRequest } from '../../../../hooks/useGetRequest';
import { getRequest, postRequest } from '../../../../utils/axiosRequests';
import InvestigationUnit from '../../partials/investigationUnit';

const InvestigationHistories = ({ selectedData, setSelectedHistories }) => {
  const [investigationList, setInvestigationList] = useState([]);
  const [units, setUnits] = useState([]);
  const invRef = useRef(null);

  const { isLoading: isUnitLoading, refetch: getUnits } = useGetRequest(
    'getUnitList',
    `units`,
    (data) => {
      setUnits(data.data);
    },
    (e) => {
      console.log(e);
    },
  );

  useEffect(() => {
    getUnits();
  }, []);

  const mergeSelectedInv = (newData) => {
    const selectedInvestigate = [
      ...(selectedData?.investigations || []),
      { name: newData, result: '', investigationDate: '' },
    ];
    selectedData.investigations = selectedInvestigate;
    setSelectedHistories({ ...selectedData });
  };

  // const mergeSelectedInv = (newData) => {
  //   setSelectedHistories((prevData) => ({
  //     ...prevData,
  //     investigations: [
  //       ...(prevData?.investigations || []),
  //       { name: newData, result: '', instruction: '' },
  //     ],
  //   }));
  // };

  const handleInvestigationUnit = (updatedData) => {
    setSelectedHistories({ ...selectedData, investigations: updatedData });
  };

  const deleteData = (itemName) => {
    const updatedInvestigations = selectedData?.investigations?.filter(
      (investigation) => investigation.name !== itemName,
    );
    setSelectedHistories({
      ...selectedData,
      investigations: updatedInvestigations,
    });
  };

  const selectedInvestigations = () => {
    return selectedData?.investigations?.map((item, index) => {
      return (
        <Row className={'mt-1'} key={index}>
          <Col md={3} className="pl-2">
            {item.name}
          </Col>
          <Col md={2} className="pl-0 pr-o">
            {/* <Form.Control
              size="sm"
              min={0}
              type="text"
              defaultValue={item.instruction}
              placeholder="Add Instruction"
              onChange={(e) =>
                investigationData(index, 'instruction', e.target.value)
              }
            /> */}
            <DatePicker
              showIcon
              selected={
                item?.investigationDate
                  ? new Date(item?.investigationDate)
                  : null
              }
              onChange={(date) =>
                investigationData(index, 'investigationDate', date)
              }
              dateFormat="dd/MM/yyyy"
              className="form-control form-control-sm"
              placeholderText="dd/mm/yyyy"
              popperPlacement="bottom-start"
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 48 48"
                >
                  <mask id="ipSApplication0">
                    <g
                      fill="none"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="4"
                    >
                      <path
                        strokeLinecap="round"
                        d="M40.04 22v20h-32V22"
                      ></path>
                      <path
                        fill="#fff"
                        d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
                      ></path>
                    </g>
                  </mask>
                  <path
                    fill="currentColor"
                    d="M0 0h48v48H0z"
                    mask="url(#ipSApplication0)"
                  ></path>
                </svg>
              }
            />
          </Col>
          <Col className="pl-0">
            <Form.Control
              size="sm"
              as="textarea"
              rows={1}
              placeholder="Add Result"
              defaultValue={item?.result}
              onChange={(e) =>
                investigationData(index, 'result', e.target.value)
              }
            />
          </Col>
          <Col md={2} className="inv-parent pr-0 pl-0">
            <InvestigationUnit
              index={index}
              units={units}
              item={item}
              selectedInvestigations={selectedData.investigations}
              action={handleInvestigationUnit}
              type={'history'}
            />
          </Col>
          <Col md={1} className="text-center">
            <span
              className="cursor-pointer"
              onClick={() => deleteData(item?.name)}
            >
              <i
                className="fa fa-times-circle pt-2"
                style={{ color: '#CB2020D9' }}
              ></i>
            </span>
          </Col>
        </Row>
      );
    });
  };

  const investigationData = (index, fieldName, val) => {
    console.log(index, fieldName, val, 'testtttt');

    selectedData.investigations[index][fieldName] = val;
    setSelectedHistories({ ...selectedData });
  };

  const handleInvestigation = async (optionVal) => {
    const selectedVal = optionVal[0]?.name;
    if (investigationList?.some((item) => item?.name === selectedVal)) {
      if (
        !selectedData?.investigations?.some((item) => item.name === selectedVal)
      ) {
        mergeSelectedInv(selectedVal);
        setInvestigationList([]);
        handleOnInputChange('');
        invRef?.current?.clear();
      }
    } else {
      await postRequest('investigations', { name: selectedVal })
        .then((data) => {
          mergeSelectedInv(selectedVal);
          setInvestigationList([]);
          invRef?.current?.clear();
        })
        .catch((error) => {
          invRef?.current?.clear();
          console.log(error);
        });
    }
  };

  const handleOnInputChange = async (searchQuery) => {
    await getRequest(
      `investigations/all-without-pagination?searchQuery=${searchQuery}`,
    )
      .then((res) => {
        setInvestigationList(res?.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    handleOnInputChange('');
  }, []);

  return (
    <div style={{ padding: '10px' }}>
      <Form.Group as={Row} className="mb-3">
        <Form.Label column sm="2" className="font-weight-bold pl-2">
          Investigations
        </Form.Label>
        <Col sm="10" className="mt-1">
          <Typeahead
            allowNew
            labelKey="name"
            ref={invRef}
            id="custom-selections-example"
            newSelectionPrefix="Click to add new: "
            options={investigationList}
            placeholder="Search / Add investigaton."
            onChange={handleInvestigation}
            onInputChange={handleOnInputChange}
            size="sm"
            renderMenuItemChildren={(option) => (
              <Fragment>
                <span>{option.name}</span>
              </Fragment>
            )}
          />
        </Col>
      </Form.Group>
      <div className="mt-3">{selectedInvestigations()}</div>
    </div>
  );
};

export default InvestigationHistories;
